// 命中 2020 2032 2033 的错误会在中间件调用这个派发器
// response example: https://bytedance.feishu.cn/wiki/wikcnRNE0f3AQGrZswE7IvJ7tgb#qlFMMS

import { AxiosRequestConfig, AxiosResponse } from 'axios';
import verification from '@byted-sdk/tiktok-web-verification';
import { TypeInitProps, TypeRequest, WebVerificationOption } from '../../types';
import { objectToString, stringToObject } from '../../utils';

export const SUSPICIOUS_LOGIN_ERROR_CODE_TO_METHOD = {
  2020: 'PASSWORD',
  2032: 'SMS',
  2033: 'EMAIL',
} as const;

type MethodName = typeof SUSPICIOUS_LOGIN_ERROR_CODE_TO_METHOD[keyof typeof SUSPICIOUS_LOGIN_ERROR_CODE_TO_METHOD];

let requestInstance: TypeRequest, fp: string;

/**
 * init:
 *  init sdk. lang params or something like these
 * call:
 * 1. call the method
 * 2. if success then retry the request
 * 2.1 rewrite the params and data when you are gonna retry the request
 * 2.2 if the request failed, then throw errors again
 * 3. if the user choose to cancel, then reject directly
 */

export const verificationView = {
  init(options: TypeInitProps & { request: TypeRequest }) {
    const { request, ...props } = options;
    requestInstance = request;
    verification.init({
      lang: options.pageLang || 'en',
      starlingZoneHost: options.starlingZoneHost,
      request,
      hooks: props.hooks,
    });
  },
  call(options: {
    method: MethodName;
    verifyTicket: string;
    commonParams?: any;
    requestInfo: {
      requestConfig: any;
      patchRequestData?: any;
    };
  }): Promise<any> {
    const { method, verifyTicket, commonParams = {}, requestInfo } = options;
    // 1. patch request data
    let requestDataStr = requestInfo.requestConfig.data || '';
    if (requestInfo.patchRequestData) {
      const originRequestData = stringToObject(requestDataStr);
      requestDataStr = objectToString({
        ...originRequestData,
        ...requestInfo.patchRequestData,
      });
    }
    // 2. retry when success
    return verification
      .call({
        method,
        params: {
          verify_ticket: verifyTicket,
          ...commonParams,
        },
      })
      .then(() => {
        return requestInstance?.({
          ...requestInfo.requestConfig,
          params: {
            ...requestInfo.requestConfig.params,
            isResend: true,
            verify_ticket: verifyTicket,
          },
          data: requestDataStr,
        });
      });
  },
};

export function dispatchVerification(options: {
  resp: AxiosResponse;
  config: AxiosRequestConfig;
}): Promise<any> {
  const { resp, config } = options;
  const errorCode =
    (resp?.data as any)?.error_code || (resp as any)?.error_code;
  const method = (SUSPICIOUS_LOGIN_ERROR_CODE_TO_METHOD as any)[
    errorCode as number
  ] as MethodName;

  const profileKey =
    (resp?.data as any)?.profile_key || (resp as any)?.profile_key;

  const verifyTicket =
    (resp?.data as any)?.verify_ticket || (resp as any)?.verify_ticket;

  const smsCodeKey =
    (resp?.data as any)?.sms_code_key || (resp as any)?.sms_code_key;

  return verificationView.call({
    method,
    verifyTicket,
    requestInfo: {
      requestConfig: config,
      patchRequestData: {
        profile_key: profileKey,
        verify_ticket: verifyTicket,
        sms_code_key: smsCodeKey,
      },
    },
  });
}
